$(document).ready(function() {

    var vehicleData = null;
    if (localStorage.getItem('tyreVehicleData')) {
        vehicleData = JSON.parse(localStorage.getItem('tyreVehicleData'));
        if (vehicleData.manufacturer && vehicleData.model && vehicleData.engine && vehicleData.width && vehicleData.size) {
            $(".last-search").css("display", "block");
            $('input[name ="vehicleId"]').val(vehicleData.id);
            $('input[name ="vehicleModel"]').val(vehicleData.model);
            $('input[name ="vehicleSpecification"]').val(vehicleData.specification);
            $('input[name ="vehicleManufacturer"]').val(vehicleData.manufacturer);
            $('input[name ="vehicleEngineType"]').val(vehicleData.engine);
            $('input[name ="width"]').val(vehicleData.width);
            if ($('input[name ="sizeTyresOnCW"]').val() !== "noChanges") {
                $('input[name ="size"]').val(vehicleData.size);
            }
            $('input[name ="profile"]').val(vehicleData.tyreProfile);
            $(".last-search.h5").text(vehicleData.manufacturer + " " + vehicleData.model + " " + vehicleData.engine);
            $('input[name ="vehicle_ids"]').val(vehicleData.id);
        } else {
            $(".last-search").css("display", "none");
        }
    } else {
        $(".last-search").css("display", "none");
    }

    var $spinner = $("#loader");
    $("#carselector-default form").addClass("preselect");
    $spinner.show();

    $("body").on("carselector-default-manufacturer-done-loading", function() {
        var manufacturer = $("#carselector-default-manufacturer").val();
        $("#carselector-default-manufacturer").val(manufacturer).trigger("change");

        $spinner.fadeOut();
        $("body").off("carselector-default-manufacturer-done-loading");
    });

    $("body").on("carselector-default-model-done-loading", function() {
        var model = $("#carselector-default-model").val();
        $("#carselector-default-model").val(model).trigger("change");
        $("body").off("carselector-default-model-done-loading");
    });

    $("body").on("carselector-default-year-of-manufacture-type-done-loading", function() {
        var series = $("#carselector-default-year-of-manufacture-type").val();
        $("#carselector-default-year-of-manufacture-type").val(series).trigger("change");
        $("body").off("carselector-default-year-of-manufacture-type-done-loading");
    });

    $("body").on("carselector-default-specific-done-loading", function() {
        var series = $("#carselector-default-specific").val();
        $("#carselector-default-specific").val(series).trigger("change");
        $("body").off("carselector-default-specific-done-loading");
        $spinner.fadeOut();
    });

    // initialise gettext
    try {
        ltd('wheelshop');
    } catch (e) {

    }

    if ($("#carselector-default").length && $("#selected_car_info").css("display") !== "none") {
        var manufacturer = vehicleData !== null ? vehicleData.manufacturer : null;
        var model = vehicleData !== null ? vehicleData.model : null;
        var engine = vehicleData !== null ? vehicleData.engine : null;
        var id = vehicleData !== null ? vehicleData.specification : null;
        selectDefaultCar(manufacturer, model, engine, id);
    } else if ($("#carselector-default").length) {
        selectDefaultCar(null, null, null, null);
    }

    $('[data-toggle="tooltipTyreByVehicle"]').addClass('tooltip-for-filters').tooltip({
        template: '<div class="tooltip-serp-filters tooltip" role="tooltip"><div class="tooltip-inner"></div></div>',
        html: true,
        placement: 'right',
        container: 'body'
    });

});

function makeAjaxRequest(cmsPageId, vehicleManufacturer) {
    $.ajax({
        url: contextPath + "/ws/jfnetwork/vehicle/manufacturers",
        method: "POST",
        data: {
            cmsPageId: cmsPageId
        },
        headers: {
            "X-CSRF-TOKEN": $("input[name='_csrf']").val()
        }
    }).done(function(data) {
        var dropdown = $("#carselector-default-manufacturer");
        $(dropdown).find('option:not([value=""])').remove();
        // A page may list its popular manufacturers first (window.popularCarManufacturers, keys as in
        // data.list), grouped like the live komplettrad.pl selector; without it the list is unchanged.
        var popular = $.isArray(window.popularCarManufacturers) ? window.popularCarManufacturers : [];
        var manufacturerOption = function (manufacturer) {
            return $("<option/>")
                .attr("value", manufacturer.key)
                .attr("data-image", "https://static.delti.com/static/simg/Logos/" + manufacturer.value.replace(/\s+/g, "") + ".png")
                .prop("selected", manufacturer.key === vehicleManufacturer)
                .text(manufacturer.value);
        };
        var popularManufacturers = $.grep(data.list, function (manufacturer) {
            return popular.indexOf(manufacturer.key) >= 0;
        });
        if (popularManufacturers.length) {
            var $popularGroup = $("<optgroup/>").attr("label", window.popularCarManufacturersLabel || "-- Most popular manufacturers --");
            var $allGroup = $("<optgroup/>").attr("label", window.allCarManufacturersLabel || "-- All manufacturers --");
            $.each(popularManufacturers, function (index, manufacturer) {
                // the chosen car stays selected in the "all" group only, so it is selected once
                $popularGroup.append(manufacturerOption(manufacturer).prop("selected", false));
            });
            $.each(data.list, function (index, manufacturer) {
                $allGroup.append(manufacturerOption(manufacturer));
            });
            $(dropdown).append($popularGroup, $allGroup);
        } else {
            $.each(data.list, function (index, manufacturer) {
                $(dropdown).append(manufacturerOption(manufacturer));
            });
        }
        $(dropdown).prop('disabled', false).trigger("focus");
        $(dropdown).parent().show();
        if (window.cwModernSelectUi) {
            // modern select UI, as the live komplettrad.pl selector: brand logos next to the label
            $(dropdown).select2({
                templateResult: cwManufacturerOptionTemplate,
                templateSelection: cwManufacturerOptionTemplate,
                placeholder: cwPlaceholder(dropdown),
                minimumResultsForSearch: 1,
                dropdownPosition: "below",
                width: "100%"
            });
            $(dropdown).data('select2').$dropdown.addClass("cw-select2-brand-dropdown");
        }
        $("body").trigger($.Event("carselector-default-manufacturer-done-loading"));
    }).fail(function(jqXHR) {
        $("#carselector-error-div").show();
    });
}

function selectDefaultCar(vehicleManufacturer, vehicleModel, vehicleEngineType, vehicleSpecification) {

    var cmsPageId = "";
    if (typeof cmsPageUid !== "undefined") {
        cmsPageId = cmsPageUid;
    }

    var preselect = $("#carselector-default form").hasClass("preselect");
    // CarSelector Default: load first dropdown (manufacturer)
    $("#carselector-default-manufacturer").prop('disabled', true)[0].options.length = 1;
    resetSelectors();
    $("#carselector-default-error").fadeOut(300, function() {
        this.remove()
    });

    var tab2Label = $('label[for="tab2"]');
    var tab2Button = $('label[for="switch-wrapper__label"]');
    var switchTab = $('label[for="swich-filter-PKW"]');
    var liElement = document.querySelector('li[data-link="byCarModel"]');
    var change = $("#car_change");
    var brandInput = $(".home-input-car-engine");

    // check if search by car model tab is already open
    // trigger ajax after window has been loaded to avoid bugs which appears if the second tab is not already loaded before checking
    if (brandInput.is(":visible")) {
        makeAjaxRequest(cmsPageId, vehicleManufacturer);
    }
    // trigger ajax when the tab2 is active
    if (tab2Label.length) {
        makeAjaxRequest(cmsPageId, vehicleManufacturer);
    // trigger for the Tirendo's switch button
    } else if (switchTab.length) {
        switchTab.one('click', function() {
            makeAjaxRequest(cmsPageId, vehicleManufacturer);
        });
        // trigger for the giga shop
    } else if ($('.btn-giga').length) {
        // trigger only if contains search by car
        if (liElement && liElement.offsetParent !== null) {
            liElement.addEventListener('click', function() {
                makeAjaxRequest(cmsPageId, vehicleManufacturer);
            }, {
                once: true
            });
        } else if (change.length) {
            change.one('click', function() {
                makeAjaxRequest(cmsPageId, vehicleManufacturer);
            });
        } else {
            makeAjaxRequest(cmsPageId, vehicleManufacturer);
        }
    }
    // every other case for search pages
    else {
        makeAjaxRequest(cmsPageId, vehicleManufacturer);
    }

    // CarSelector Default: load second dropdown (class(aka model))
    $('#carselector-default-manufacturer').on('change', function() {
        resetError();
        if (this.value !== '') {
            $('input[name=vehicleManufacturer]').val(this.value);
        }
        resetSelectors();
        $("#carselector-default-model").trigger("change");
        $("#carselector-default-year-of-manufacture-type").trigger("change");
        $("#carselector-default-specific").trigger("change");

        if (this.value === "") {
            return;
        }

        $.ajax({
            url: contextPath + "/ws/jfnetwork/vehicle/classes",
            method: "POST",
            data: {
                manufacturer: this.value,
                cmsPageId: cmsPageId
            },
            headers: {
                "X-CSRF-TOKEN": $("input[name='_csrf']").val()
            }
        }).done(function(data) {
            fillModelCar(vehicleModel, data);
            $("#carselector-default-model").trigger("change");
        }).fail(function(jqXHR) {
            $("#carselector-error-div").show();
        });
    });

    // CarSelector Default: load third dropdown (type)
    $('#carselector-default-model').on('change', function() {
        resetError();
        if (this.value !== '') {
            $('input[name=vehicleModel]').val(this.value.split("::")[1]);
        }
        $("#carselector-default-year-of-manufacture-type").prop('disabled', true)[0].options.length = 1;
        $("#carselector-default-specific").prop('disabled', true)[0].options.length = 1;
        if ($("#carselector-tyre-size").length) {
            $("#carselector-tyre-size").prop('disabled', true)[0].options.length = 1;
        }
        if ($("#carselector-default-submit-tyres")) {
            $("#carselector-default-submit-tyres").prop('disabled', true);
        }
        if ($("#carselector-default-submit-cw")) {
            $("#carselector-default-submit-cw").prop('disabled', true);
        }
        $("#carselector-default-submit").prop('disabled', true);
        $("#carselector-default-error").fadeOut(300, function() {
            this.remove()
        });

        $("#carselector-default-year-of-manufacture-type").trigger("change");
        $("#carselector-default-specific").trigger("change");

        if (this.value === "") {
            return;
        }

        $.ajax({
            url: contextPath + "/ws/jfnetwork/vehicle/years-types",
            method: "POST",
            data: {
                carClass: this.value,
                cmsPageId: cmsPageId
            },
            headers: {
                "X-CSRF-TOKEN": $("input[name='_csrf']").val()
            }
        }).done(function(data) {
            fillYearOfManufactureTypeCar(vehicleSpecification, data);
            $("#carselector-default-year-of-manufacture-type").trigger("change");
            // $("body").trigger($.Event("carselector-default-type-done-loading"));
            $("body").trigger($.Event("carselector-default-year-of-manufacture-type-done-loading"));
        }).fail(function(jqXHR) {
            $("#carselector-error-div").show();
        });
    });

    // CarSelector Default: load forth dropdown (type-details)
    $('#carselector-default-year-of-manufacture-type').on('change', function() {
        resetError();
        if (this.value !== '') {
            $('input[name=vehicleSpecification]').val(this.value.split("::")[3] + " " + typeTranslation + " " + this.value.split("::")[4]);
        }
        $("#carselector-default-specific").prop('disabled', true)[0].options.length = 1;
        if ($("#carselector-tyre-size").length) {
            $("#carselector-tyre-size").prop('disabled', true)[0].options.length = 1;
        }
        if ($("#carselector-default-submit-tyres")) {
            $("#carselector-default-submit-tyres").prop('disabled', true);
        }
        if ($("#carselector-default-submit-cw")) {
            $("#carselector-default-submit-cw").prop('disabled', true);
        }
        $("#carselector-default-submit").prop('disabled', true);
        $("#carselector-default-error").fadeOut(300, function() {
            this.remove()
        });

        $("#carselector-default-specific").trigger("change");

        if (this.value === "") {
            return;
        }
        $.ajax({
            url: contextPath + "/ws/jfnetwork/vehicle/series-versions",
            method: "POST",
            data: {
                carClass: this.value,
                cmsPageId: cmsPageId
            },
            headers: {
                "X-CSRF-TOKEN": $("input[name='_csrf']").val()
            }
        }).done(function(data) {
            fillSeriesVersionCar(vehicleEngineType, data);
            $("#carselector-default-specific").trigger("change");
            $("body").trigger($.Event("carselector-default-specific-done-loading"));
        }).fail(function(jqXHR) {
            $("#carselector-error-div").show();
        });
    });

    // CarSelector Default: show submit on fifth dropdown selection
    $("#carselector-default-specific").on('change', function() {
        resetError();
        preselect = false;
        if (this.value !== '') {
            $('input[name=vehicleId]').val(this.value.split("::")[0]);
            $('input[name=vehicleEngineType]').val($("#carselector-default-specific option:selected").text());
            $('input[name=fuelCode]').val(this.value.split("::")[1]);
            $("#carselector-default-submit").prop('disabled', false).trigger("focus");
        } else {
            $("#carselector-default-submit").prop('disabled', true);
        }
    });
}

function resetSelectors() {
    $("#carselector-default-model").prop('disabled', true)[0].options.length = 1;
    $("#carselector-default-year-of-manufacture-type").prop('disabled', true)[0].options.length = 1;
    $("#carselector-default-specific").prop('disabled', true)[0].options.length = 1;
    if ($("#carselector-tyre-size").length) {
        $("#carselector-tyre-size").prop('disabled', true)[0].options.length = 1;
    }
    if ($("#carselector-default-submit-tyres")) {
        $("#carselector-default-submit-tyres").prop('disabled', true);
    }
    if ($("#carselector-default-submit-cw")) {
        $("#carselector-default-submit-cw").prop('disabled', true);
    }
    $("#carselector-default-submit").prop('disabled', true);
}

function fillModelCar(vehicleModel, data) {
    var dropdown = $("#carselector-default-model");
    $(dropdown).find('option:not([value=""])').remove();
    $.each(data.list, function(index, model) {
        if (model.value === vehicleModel) {
            $(dropdown).append(
                "<option selected value='" + model.key + "'>" + model.value + "</option>");
        } else {
            $(dropdown).append(
                "<option value='" + model.key + "'>" + model.value + "</option>");
        }
    });

    if (data.list.length === 1) {
        // select first element
        $(dropdown).val(data.list[0].key);
        $(dropdown).trigger("change");
    }

    $(dropdown).prop('disabled', false).trigger("focus");
    $(dropdown).parent().show();
    if (window.cwModernSelectUi) {
        $(dropdown).select2({
            placeholder: cwPlaceholder(dropdown),
            minimumResultsForSearch: 15,
            dropdownPosition: "below",
            width: "100%"
        });
        $(dropdown).data('select2').$dropdown.addClass("cw-select2-brand-dropdown");
    }
}

function fillYearOfManufactureTypeCar(vehicleEngineType, data) {
    var versionDropdown = $("#carselector-default-year-of-manufacture-type");
    $(versionDropdown).find('option:not([value=""])').remove();
    if (cwTableSelectUi()) {
        // table listing with a Baujahr / Typ header row, as the live komplettrad.pl selector
        $(versionDropdown).append($("<option>", {value: " ", text: " ", "data-title": 1, disabled: true}));
    }
    var yearOfManufactureTypes = cwTableSelectUi()
        ? cwNewestFirst(data.yearOfManufactureType) : data.yearOfManufactureType;
    $.each(yearOfManufactureTypes, function(index, yearTypes) {
        var yearOfManufactureTypeText = yearTypes.name.split("::")[0] + " " + typeTranslation + " " + yearTypes.name.split("::")[1];
        if (cwTableSelectUi()) {
            $(versionDropdown).append($("<option>", {
                value: yearTypes.key,
                "data-typeyearfromto": yearTypes.name.split("::")[0],
                "data-type": yearTypes.name.split("::")[1]
            }).prop("selected", yearOfManufactureTypeText === vehicleEngineType).text(yearOfManufactureTypeText));
        } else if (yearOfManufactureTypeText === vehicleEngineType) {
            $(versionDropdown).append("<option selected value='" + yearTypes.key + "'>" + yearOfManufactureTypeText + "</option>");
        } else {
            $(versionDropdown).append("<option value='" + yearTypes.key + "'>" + yearOfManufactureTypeText + "</option>");
        }
    });

    if (data.yearOfManufactureType.length === 1) {
        // select first element
        $(versionDropdown).val(data.yearOfManufactureType[0].key);
        $(versionDropdown).trigger("change");
    } else if (data.yearOfManufactureType.length === 0) {
        $("#carselector-error-div").show();
    }
    $(versionDropdown).prop('disabled', false).trigger("focus");
    $(versionDropdown).parent().show();
    if (cwTableSelectUi()) {
        $(versionDropdown).select2({
            templateResult: cwTypeOptionTemplate,
            placeholder: cwPlaceholder(versionDropdown),
            minimumResultsForSearch: 15,
            dropdownPosition: "below",
            width: "100%"
        });
        cwTableSelect2Classes(versionDropdown, "cw-select2-table-dropdown cw-select2-type-dropdown");
    }
}

// A series version's name is "<version>::<kW>::<PS>::<series size>::<fuel code>".
// Labelled like the live komplettrad.pl selector: "1.0 TSI 85 kW/116 PS", with
// "(Seriengröße Min. 15 Zoll)" added only where the same version and power come in several
// series sizes - those are the entries the customer has to tell apart.
function seriesVersionLabel(parts, withSeriesSize) {
    var label = parts[0] + " " + parts[1] + " kW/" + parts[2] + " PS";
    // a series size of 0 is no size (cwCocMinSize): never "Min. 0 Zoll"
    if (withSeriesSize && cwCocMinSize(parts)) {
        label += " (" + standardSizeTranslation + " Min. " + parts[3] + " " + inchTranslation + ")";
    }
    return label;
}

// The pre-2026 label, so a car stored with it (my cars, local storage) is still preselected.
function legacySeriesVersionLabel(parts, withSeriesSize) {
    return parts[0] + " kW/" + parts[1] + " PS" + parts[2] + " "
        + (parts[3] && withSeriesSize ? standardSizeTranslation + " " + parts[3] + " " + inchTranslation : "");
}

// --- modern select2 UI (live komplettrad.pl parity) ---
// Only used by pages that set window.cwModernSelectUi (the complete-wheels / rims landings); every
// other page rendering this file keeps the plain selects. Captions and fuel labels come from the
// page (window.cwSeriesHeaders / window.cwTypeHeaders / window.cwFuelLabels, seeded via messages).

// The Baujahr/Typ and Serie tables alone (DJSD-1621): rdlite's modern UI has them, and the other themes'
// cw/rims landings turn on just them with window.cwSeriesTableUi (shared carSelectorComponent.html),
// keeping their plain brand and model selects. Each theme styles the tables in its own css.
function cwTableSelectUi() {
    return !!(window.cwModernSelectUi || window.cwSeriesTableUi);
}

// The table selects' select2 classes. Outside rdlite's modern UI the dropdown and the closed select also
// carry cw-select2-themed, which scopes the themes' table css (theme-lite / theme-giga cw-series-table.css)
// away from rdlite, whose bundle includes theme-lite's.
function cwTableSelect2Classes(dropdown, classes) {
    var select2 = $(dropdown).data('select2');
    if (window.cwModernSelectUi) {
        select2.$dropdown.addClass(classes);
    } else {
        select2.$dropdown.addClass(classes + " cw-select2-themed");
        select2.$container.addClass("cw-select2-themed");
    }
}

function cwManufacturerOptionTemplate(state) {
    var $option = $(state.element);
    // the empty "auswählen" placeholder option renders as plain text, without the logo cell
    if ($option.is("optgroup") || !$option.attr("value")) {
        return $("<span>").text(state.text);
    }
    // Every brand row keeps the reserved logo cell, so a missing logo file (404) hides itself
    // without shifting the label to the left edge, as the rows with a logo stay aligned.
    var $logo = $("<img class='cw-select2-logo'>").attr("alt", "");
    if ($option.attr("data-image")) {
        $logo.attr("src", $option.attr("data-image")).attr("onerror", "this.style.display='none'");
    }
    return $("<div class='cw-select2-row'>")
        .append($("<div class='cw-select2-logo-cell'>").append($logo))
        .append($("<div class='cw-select2-col'>").text(state.text));
}

function cwTypeOptionTemplate(state) {
    var $option = $(state.element);
    var headers = window.cwTypeHeaders || {};
    if (!$option.attr("value")) {
        return $("<span>").text(state.text);
    }
    if (1 == $option.data("title")) {
        return $("<div class='cw-select2-row'>")
            .append($("<div class='cw-select2-col'><strong>" + (headers.year || "Year") + "</strong></div>"))
            .append($("<div class='cw-select2-col'><strong>" + (headers.type || "Type") + "</strong></div>"));
    }
    if (cwStackedTable()) {
        return cwStackedTypeOption($option);
    }
    return $("<div class='cw-select2-row'>")
        .append($("<div class='cw-select2-col'>").text($option.attr("data-typeyearfromto") || ""))
        .append($("<div class='cw-select2-col'>").text($option.attr("data-type") || ""));
}

// Below this width the table dropdowns are lists (DFNG-16543): each year/type and each series is a
// block, one value per line, as on the live komplettrad.pl mobile selector. Phones and tablets: the
// series table opens at the select's left edge and needs ~650px, which overflows the page below the lg
// breakpoint. Must match the @media of the table dropdowns in rdlite cw-rd2021-utilities.css, which
// hides their header row there.
var CW_STACKED_TABLE_QUERY = "(max-width: 991.98px)";

function cwStackedTable() {
    return !!(window.matchMedia && window.matchMedia(CW_STACKED_TABLE_QUERY).matches);
}

// one year/type as a block: Baujahr in bold, then "Typ <type>"
function cwStackedTypeOption($option) {
    var $block = $("<div class='cw-select2-stack'>")
        .append($("<div class='cw-select2-stack-title'>").text($option.attr("data-typeyearfromto") || ""));
    if ($option.attr("data-type")) {
        $block.append($("<div>").text(typeTranslation + " " + $option.attr("data-type")));
    }
    return $block;
}

// one series as a block: Serie in bold, then Kraftstoff, Leistung, Maximale Leistung and Seriengröße,
// each named where its value alone would not say what it is
function cwStackedVersionOption($option, headers) {
    var $block = $("<div class='cw-select2-stack'>");
    var line = function (text, cssClass) {
        if (text) {
            $block.append($("<div>").addClass(cssClass || "").text(text));
        }
    };
    line($option.attr("data-version"), "cw-select2-stack-title");
    line($option.attr("data-fuel"));
    line($option.attr("data-power"));
    if (1 == $option.data("showmaxpower") && $option.attr("data-maxpower")) {
        line($option.attr("data-maxpower") + " (" + (headers.maxPower || "Maximum power") + ")");
    }
    if (1 == $option.data("showcocminsize") && $option.attr("data-cocminsize")) {
        line($option.attr("data-cocminsize") + " " + inchTranslation + " " + (headers.seriesSize || "Standard size"),
            "cw-select2-stack-muted");
    }
    if (1 == $option.data("showboltpattern") && $option.attr("data-boltpattern")) {
        line((headers.boltCircle || "Bolt circle") + " " + $option.attr("data-boltpattern"), "cw-select2-stack-muted");
    }
    return $block;
}

function cwVersionOptionTemplate(state) {
    var $option = $(state.element);
    var headers = window.cwSeriesHeaders || {};
    if (!$option.attr("value")) {
        return $("<span>").text(state.text);
    }
    if (1 == $option.data("isheader")) {
        var $head = $("<div class='cw-select2-row'>")
            .append($("<div class='cw-select2-col'><strong>" + (headers.fuel || "Fuel") + "</strong></div>"))
            .append($("<div class='cw-select2-col'><strong>" + (headers.series || "Series") + "</strong></div>"))
            .append($("<div class='cw-select2-col'><strong>" + (headers.power || "Power") + "</strong></div>"));
        if (1 == $option.data("showmaxpower")) {
            $head.append($("<div class='cw-select2-col'><strong>" + (headers.maxPower || "Maximum power") + "</strong></div>"));
        }
        if (1 == $option.data("showcocminsize")) {
            $head.append($("<div class='cw-select2-col'><strong>" + (headers.seriesSize || "Standard size") + "</strong></div>"));
        }
        if (1 == $option.data("showboltpattern")) {
            $head.append($("<div class='cw-select2-col'><strong>" + (headers.boltCircle || "Bolt circle") + "</strong></div>"));
        }
        return $head;
    }
    if (cwStackedTable()) {
        return cwStackedVersionOption($option, headers);
    }
    var $row = $("<div class='cw-select2-row'>")
        .append($("<div class='cw-select2-col'>").text($option.attr("data-fuel") || ""))
        .append($("<div class='cw-select2-col'>").text($option.attr("data-version") || ""))
        .append($("<div class='cw-select2-col'>").text($option.attr("data-power") || ""));
    if (1 == $option.data("showmaxpower")) {
        $row.append($("<div class='cw-select2-col'>").text($option.attr("data-maxpower") || ""));
    }
    if (1 == $option.data("showcocminsize")) {
        $row.append($("<div class='cw-select2-col'>").text($option.attr("data-cocminsize") ? $option.attr("data-cocminsize") + " " + inchTranslation : ""));
    }
    if (1 == $option.data("showboltpattern")) {
        $row.append($("<div class='cw-select2-col'>").text($option.attr("data-boltpattern") || ""));
    }
    return $row;
}

// the select's empty option text ("auswählen"): as the select2 placeholder it shows while nothing is
// chosen and is left out of the open list, so a table dropdown starts with its header row
function cwPlaceholder(dropdown) {
    return $(dropdown).find('option[value=""]').first().text();
}

// The MasterData v1 API lists the year/type entries oldest first; the selector shows them newest
// first. A name is "<from>-<to>::<type>" ("2024-" still built): by start year, then the open-ended
// or later-ending entry first; the sort is stable, so the API order breaks remaining ties.
function cwNewestFirst(yearOfManufactureTypes) {
    var years = function (entry) {
        var range = entry.name.split("::")[0].split("-");
        return [parseInt(range[0], 10) || 0, parseInt(range[1], 10) || Number.MAX_SAFE_INTEGER];
    };
    return yearOfManufactureTypes.map(function (entry, index) {
        return {entry: entry, years: years(entry), index: index};
    }).sort(function (a, b) {
        return (b.years[0] - a.years[0]) || (b.years[1] - a.years[1]) || (a.index - b.index);
    }).map(function (item) {
        return item.entry;
    });
}

// Leistung and Maximale Leistung of a series entry. SeriesVersionConverter folds a maxPower into the
// power part as "<maxPower>(<kW>)" for the plain-select label, so the table takes the KBA kW back out
// of the brackets and shows maxPower in its own column, its PS derived the way JFnetwork does
// (PowerConversion). A maxPower of 0 means none: that row shows only the power.
function cwSeriesPower(parts) {
    var kw = $.trim(parts[1] || "");
    var folded = /^[\d.]+\s*\(\s*([\d.]+)\s*\)$/.exec(kw);
    if (folded) {
        kw = folded[1];
    }
    var maxKw = $.trim(parts[5] || "");
    var maxKwValue = parseFloat(maxKw);
    return {
        power: kw + " kW/" + parts[2] + " PS",
        maxPower: maxKwValue > 0 ? maxKw + " kW/" + Math.round(maxKwValue * 1.35962) + " PS" : ""
    };
}

// Seriengröße of a series entry in the table. MasterData v1 sends 0 for a car without one, which
// would read "0 Zoll": a size of 0 is no size, so the cell stays empty.
function cwCocMinSize(parts) {
    var size = $.trim(parts[3] || "");
    return parseFloat(size) > 0 ? size : "";
}

// The Lochkreis column is hidden for now (DFNG-16543). Its data and rendering stay in place:
// set this to true to show it again where the data has a bolt pattern.
var CW_SHOW_BOLT_PATTERN = false;

function cwFuelLabel(code) {
    // an unknown code shows an empty cell, as on Perl, never the raw KBA code
    var labels = window.cwFuelLabels || {};
    return labels[code] || "";
}

function fillSeriesVersionCar(vehicleSpecification, data) {
    var dropdown = $("#carselector-default-specific");
    $(dropdown).find('option:not([value=""])').remove();
    var occurrences = {};
    $.each(data.seriesVersion, function(index, typedetails) {
        var base = seriesVersionLabel(typedetails.name.split("::"), false);
        occurrences[base] = (occurrences[base] || 0) + 1;
    });
    if (cwTableSelectUi()) {
        // table listing, as the live komplettrad.pl selector: Kraftstoff / Serie / Leistung always,
        // Maximale Leistung / Seriengröße / Lochkreis where the data has them (Lochkreis is hidden for now,
        // see CW_SHOW_BOLT_PATTERN)
        var showMaxPower = false, showCocMinSize = false, showBoltPattern = false;
        $.each(data.seriesVersion, function(index, typedetails) {
            var parts = typedetails.name.split("::");
            if (cwSeriesPower(parts).maxPower) showMaxPower = true;
            if (cwCocMinSize(parts)) showCocMinSize = true;
            if (CW_SHOW_BOLT_PATTERN && parts[6]) showBoltPattern = true;
        });
        var columnFlags = {
            "data-showmaxpower": showMaxPower ? 1 : 0,
            "data-showcocminsize": showCocMinSize ? 1 : 0,
            "data-showboltpattern": showBoltPattern ? 1 : 0
        };
        $(dropdown).append($("<option>", $.extend({value: " ", text: " ", "data-isheader": 1, disabled: true}, columnFlags)));
    }
    $.each(data.seriesVersion, function(index, typedetails) {
        var parts = typedetails.name.split("::");
        var grouped = occurrences[seriesVersionLabel(parts, false)] > 1;
        var seriesVersionText = seriesVersionLabel(parts, grouped);
        var selected = typedetails.key === vehicleSpecification || seriesVersionText === vehicleSpecification
            || legacySeriesVersionLabel(parts, grouped) === vehicleSpecification;
        if (cwTableSelectUi()) {
            var power = cwSeriesPower(parts);
            $(dropdown).append($("<option>", $.extend({
                value: typedetails.key + "::" + parts[4],
                "data-version": parts[0],
                "data-power": power.power,
                "data-maxpower": power.maxPower,
                "data-cocminsize": cwCocMinSize(parts),
                "data-fuel": cwFuelLabel(parts[4]),
                "data-boltpattern": parts[6] || ""
            }, columnFlags)).prop("selected", selected).text(seriesVersionText));
        } else {
            $(dropdown).append($("<option/>")
                .attr("value", typedetails.key + "::" + parts[4])
                .prop("selected", selected)
                .text(seriesVersionText));
        }
    });

    if (data.seriesVersion.length === 1) {
        // select first element
        $(dropdown).val(data.seriesVersion[0].key + "::" + data.seriesVersion[0].name.split("::")[4]);
        $('#carselector-default-specific').trigger("change");
        $("#carselector-default-submit").prop('disabled', false).trigger("focus");
    } else if (data.seriesVersion.length === 0) {
        $("#carselector-error-div").show();
    }

    $(dropdown).prop('disabled', false).trigger("focus");
    $(dropdown).parent().show();
    if (cwTableSelectUi()) {
        // up to six columns do not fit the select's width: cw-select2-series-dropdown widens the table,
        // and below CW_STACKED_TABLE_QUERY lists each series as a block instead (rdlite cw-rd2021-utilities.css)
        $(dropdown).select2({
            templateResult: cwVersionOptionTemplate,
            placeholder: cwPlaceholder(dropdown),
            minimumResultsForSearch: "Infinity",
            dropdownPosition: "below",
            width: "100%"
        });
        cwTableSelect2Classes(dropdown, "cw-select2-table-dropdown cw-select2-series-dropdown");
    }
}

function resetError() {
    //reset error message to default and hide previous error
    $("#carselector-error-span").text(defaultErrorMessage);
    $("#carselector-error-div").hide();
}

$("#driveRight-carselector-tyre-size").on('change', function() {
    preselect = false;
    if (this.value != '') {
        populateVehicleInfoSearchForm($("#driveRight-carselector-tyre-size").val());
        $("#tyreDimensionsSubmitButton").prop('disabled', false);
        $("#submitButtonDiv").show();
    } else {
        $("#tyreDimensionsSubmitButton").prop('disabled', true);
    }
});

var populateVehicleInfoSearchForm = function(data) {
    // split by pipe creates individual values
    var values = data.split("|");
    var formValues = {
        width: values[0],
        profile: values[1],
        constructionType: values[2],
        size: values[3],
        loadIndex: values[4],
        speedRating: values[5]
    };
    for (var key in formValues) {
        $("#searchByVehicleInfoForm input[name='" + key + "']").val(formValues[key]);
    }
};

function chooseMyCar(vehicleManufacturer, vehicleModel, vehicleEngineType, vehicleSpecification) {

    var cmsPageId = "";
    resetError();
    resetSelectors();

    $('input[name=vehicleManufacturer]').val(vehicleManufacturer);
    $('input[name=vehicleModel]').val(vehicleModel);
    $('input[name=vehicleSpecification]').val(vehicleSpecification);

    $("#carselector-default-manufacturer").val(vehicleManufacturer);
    $("#carselector-default-manufacturer").trigger("change-car");

    $.ajax({
        url: contextPath + "/ws/jfnetwork/vehicle/classes",
        method: "POST",
        data: {
            manufacturer: vehicleManufacturer,
            cmsPageId: cmsPageId
        },
        headers: {
            "X-CSRF-TOKEN": $("input[name='_csrf']").val()
        }
    }).done(function(data) {
        fillModelCar(vehicleModel, data);
        $("#carselector-default-model").trigger("change-car");
        if (data.list.length > 1) {
            $.ajax({
                url: contextPath + "/ws/jfnetwork/vehicle/years-types",
                method: "POST",
                data: {
                    carClass: $("#carselector-default-model").val(),
                    cmsPageId: cmsPageId
                },
                headers: {
                    "X-CSRF-TOKEN": $("input[name='_csrf']").val()
                }
            }).done(function(data) {
                fillYearOfManufactureTypeCar(vehicleSpecification, data);
                $("#carselector-default-year-of-manufacture-type").trigger("change-car");
                $.ajax({
                    url: contextPath + "/ws/jfnetwork/vehicle/series-versions",
                    method: "POST",
                    data: {
                        carClass: $("#carselector-default-year-of-manufacture-type").val(),
                        cmsPageId: cmsPageId
                    },
                    headers: {
                        "X-CSRF-TOKEN": $("input[name='_csrf']").val()
                    }
                }).done(function(data) {
                    fillSeriesVersionCar(vehicleEngineType, data);

                    $("#carselector-default-specific").trigger("change-car");
                    $("#carselector-default-specific").trigger("change");

                    $("body").trigger($.Event("carselector-default-specific-done-loading"));
                }).fail(function(jqXHR) {
                    $("#carselector-error-div").show();
                });
            }).fail(function(jqXHR) {
                $("#carselector-error-div").show();
            });
        }
    }).fail(function(jqXHR) {
        $("#carselector-error-div").show();
    });
}